module.exports = __webpack_public_path__ + "static/media/Tomato.f8921689.png";